<template>
  <main>
    <PageIntro
      :heading="'Reset your <span>' +configStrings.productName + ' password</span>'"
      :body="'<p>To reset the password for your Celtic FC Digital Account please enter a new password below</p>'" />
    <ResetPasswordForm />
    <FooterShout :type="'signin'"/>
  </main>
</template>

<script>
  import ResetPasswordForm from '@/components/ResetPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ResetPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>